export default __webpack_public_path__ + "images/af31fa8675608fca77f81710286dc9d3-jewelry.jpg";